import React from 'react';
interface InfoBoxProps {
  icon: React.ReactNode;
  children: React.ReactNode;
}
export const InfoBox: React.FC<InfoBoxProps> = ({
  icon,
  children
}) => {
  return <div className="bg-white/10 p-4 rounded-lg mb-6 flex items-start" data-id="element-759">
      <div className="h-5 w-5 text-[#CDA735] mt-0.5 flex-shrink-0" data-id="element-760">{icon}</div>
      <div className="ml-3 text-white/90 text-sm" data-id="element-761">{children}</div>
    </div>;
};